module.exports = "/_next/static/images/5663e84ce2b7f3f243cce6046b677ff1-izzi-icon.svg.webp";